'use client';

import { RoicValues } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

interface Props {
  values: RoicValues;
  onValuesChange: (field: keyof RoicValues, value: number) => void;
  translations: ToolsTranslations['roic'];
}

export default function CalculatorInputs({ values, onValuesChange, translations }: Props) {
  const handleChange = (field: keyof RoicValues) => (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value.replace(/\s/g, '').replace(/,/g, '');
    const value = Number(raw);
    onValuesChange(field, isNaN(value) ? 0 : value);
  };

  const inputClass = "w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500";

  return (
    <div className="space-y-6">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">{translations.netIncomeAfterTax}</label>
        <input type="text" value={values.netIncomeAfterTax.toLocaleString('sv-SE')} onChange={handleChange('netIncomeAfterTax')} className={inputClass} placeholder="0" />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">{translations.dividends}</label>
        <input type="text" value={values.dividends.toLocaleString('sv-SE')} onChange={handleChange('dividends')} className={inputClass} placeholder="0" />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">{translations.longTermDebt}</label>
        <input type="text" value={values.longTermDebt.toLocaleString('sv-SE')} onChange={handleChange('longTermDebt')} className={inputClass} placeholder="0" />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">{translations.equity}</label>
        <input type="text" value={values.equity.toLocaleString('sv-SE')} onChange={handleChange('equity')} className={inputClass} placeholder="0" />
      </div>
    </div>
  );
}


